module.exports = __webpack_public_path__ + "static/img/031 2.03ba1aa2.jpg";